/**
 * @author Srijan Shakya
 * @description https://marvelapp.com/4g4b5dg/screen/60681743
 */

import { memo } from 'react';
import CheckBox from '@components/@core/CheckBox';
import Thumbnail from '@components/@core/Thumbnail';

const ReportItem = ({ data, perPage }) => (
    <div className="training-competency-report-item">
        <div className="report-item desktop-screen">
            <div className="d-flex-7 text-start text-400 mb-2">
                <p className="dsl-m12 text-400">Course</p>
            </div>
            <div className="d-flex-1 text-end ssm-left mb-2">
                <p className="dsl-m12 text-400">Modules</p>
            </div>
            <div className="d-flex-2 text-end ssm-left mb-2">
                <p className="dsl-m12 text-400">Completed</p>
            </div>
            <div className="d-flex-2 text-end ssm-left mb-2">
                <p className="dsl-m12 text-400">Past Due</p>
            </div>
            <div className="d-flex-1" />
            <div className="d-flex-1">
                <p className="dsl-m12 text-400">Employees:</p>
            </div>
            <div className="d-flex-2 text-end ssm-left">
                <p className="dsl-m12 text-400">Assigned</p>
            </div>
            <div className="d-flex-2 text-end ssm-left mb-2">
                <p className="dsl-m12 text-400">In progress</p>
            </div>
            <div className="d-flex-2 text-end ssm-left mb-2">
                <p className="dsl-m12 text-400">Completed</p>
            </div>
        </div>
        {data.map((training, index) => {
            const { data, children_complete, children_past_due } = training;
            const { child_count, thumb_url, name, assigned } = data;
            if (index < perPage) {
                return (
                    <div className="report-item d-flex ssm-column py-2" key={training.id}>
                        <div className="d-flex d-flex-7 text-start text-400 mb-2">
                            <CheckBox className="my-auto me-2" size="regular" checked={false} disabled />
                            <Thumbnail source={thumb_url} size="tiny" />
                            <div className="d-flex-1 ms-2 ai-s-center ssm-ai-s-start">
                                <p className="dsl-b12 truncate-two mt-1 mb-0">{name}</p>
                            </div>
                        </div>
                        <div className="d-flex-1 text-end ssm-left d-h-start justify-content-md-end w-100 py-2 ps-0 ssp-l-4">
                            <label className="dsl-b14 mobile-screen mb-0 w-30">Module</label>
                            <p className="dsl-b14 text-500 mt-1 ssm-t-0 mb-0 me-2">{child_count || 0}</p>
                        </div>
                        <div className="d-flex-2 text-end ssm-left d-h-start justify-content-md-end w-100 py-2 ps-0 ssp-l-4">
                            <label className="dsl-b14 mobile-screen mb-0 w-30">Completed</label>
                            <p className="dsl-b14 text-500 mt-1 ssm-t-0 mb-0 me-2">{children_complete}</p>
                        </div>
                        <div className="d-flex-2 text-end ssm-left d-h-start justify-content-md-end w-100 py-2 ps-0 ssp-l-4">
                            <label className="dsl-b14 mobile-screen mb-0 w-30">PastDue</label>
                            <p className="dsl-b14 text-500 mt-1 ssm-t-0 mb-0 me-2">{children_past_due}</p>
                        </div>
                        <div className="d-flex-1" />
                        <div className="d-flex-1" />
                        <div className="d-flex-2 text-end ssm-left d-h-start justify-content-md-end w-100 py-2 ps-0 ssp-l-4">
                            <label className="dsl-b14 mobile-screen mb-0 w-30">Assigned</label>
                            <p className="dsl-b14 text-500 mt-1 ssm-t-0 mb-0">{assigned || 0}</p>
                        </div>
                        <div className="d-flex-2 text-end ssm-left d-h-start justify-content-md-end w-100 py-2 ps-0 ssp-l-4">
                            <label className="dsl-b14 mobile-screen mb-0 w-30">InProgress</label>
                            <p className="dsl-b14 text-500 mt-1 ssm-t-0 mb-0">0</p>
                        </div>
                        <div className="d-flex-2 text-end ssm-left d-h-start justify-content-md-end w-100 py-2 ps-0 ssp-l-4">
                            <label className="dsl-b14 mobile-screen mb-0 w-30">Completed</label>
                            <p className="dsl-b14 text-500 mt-1 ssm-t-0 mb-0">0</p>
                        </div>
                    </div>
                );
            }
        })}
    </div>
);

export default memo(ReportItem);
